<template>
  <div class="navbar-header d-xl-block d-none">
    <ul class="nav navbar-nav">
      <li class="nav-item">
        <b-link
          class="navbar-brand"
          to="/"
        >
          <span class="brand-logo">
            <b-img
              :src="appLogoImage"
              :width="appConfig.logo_size"
              alt="logo"
              :class="[appConfig.logo_only ? 'mw-100' : '']"
            />
          </span>
          <h2
            v-if="!appConfig.logo_only"
            class="brand-text mb-0"
          >
            {{ appName }}
          </h2>
        </b-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { BLink, BImg } from 'bootstrap-vue'
import store from '@/store'

export default {
  components: {
    BLink,
    BImg,
  },
  computed: {
    appConfig() {
      return store.state.app.appConfig
    },
    appName() {
      return this.appConfig.brand
    },
    appLogoImage() {
      return `/storage/images/logo/${this.appConfig.logo}`
    },
  },
}
</script>

<style>

</style>
